module.exports = __webpack_public_path__ + "static/img/8.291f891.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/8.png
// module id = zDNg
// module chunks = 0